import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import Autocomplete, {
  AutocompleteProps,
  OptionShape,
} from "@civicplus/preamble-ui/lib/Autocomplete";
import { RootState, AppDispatch } from "../../../app/store";
import { getCategoriesAsync, updateEventFilters } from "../../../actions";
import { lighten } from "@material-ui/core";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";

const useStyles = makeStyles(theme => ({
  inputBorderColor: {
    "& fieldset": {
      borderColor: lighten(theme.palette.grey["600"], 0.2),
    },
  },
}));

const CategoriesCombo: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const eventFilters = useSelector((state: RootState) => state.eventFilters);
  const eventCategories = useSelector(
    (state: RootState) => state.eventCategories
  );
  const history = useHistory();
  const classes = useStyles();

  const onEventFilterChange = (
    selected: OptionShape[] | OptionShape | undefined
  ) => {
    let values: number[] = [];
    if (Array.isArray(selected)) {
      values = selected
        .map((x: OptionShape) =>
          typeof x.value === "number" ? x.value : undefined
        )
        .filter((v): v is number => v !== undefined);
    } else if (selected && typeof selected === "object") {
      values = [selected.value as number];
    }
    dispatch(
      updateEventFilters({
        categories: values,
      })
    );
  };

  useEffect(() => {
    if (eventCategories === null) {
      getCategoriesAsync()(dispatch);
    }
  }, [dispatch, eventCategories]);

  useEffect(() => {
    if (history) {
      const params = new URLSearchParams(history.location.search);
      if (eventFilters.categories && eventFilters.categories.length) {
        params.set("category_id", eventFilters.categories.join());
      } else {
        params.delete("category_id");
      }
      history.replace({
        pathname: history.location.pathname,
        search: `?${decodeURIComponent(params.toString())}`,
      });
    }
  }, [eventFilters.categories, history]);

  const selectedValues: AutocompleteProps["value"] = [];
  eventCategories?.forEach(category => {
    if (eventFilters?.categories?.includes(category.id)) {
      selectedValues.push({
        value: category.id,
        label: category.categoryDesc,
      });
    }
  });

  return (
    <Autocomplete
      id="categoriesAutocomplete"
      label="Event Categories"
      placeholder="Type or select an event category to filter..."
      onChange={onEventFilterChange as (value: unknown) => void}
      value={selectedValues}
      multiSelect={true}
      isInDialog={true}
      noOptionsMessage="No event category found"
      options={eventCategories?.map(category => ({
        value: category.id,
        label: category.categoryDesc,
      }))}
      className={classes.inputBorderColor}
    />
  );
};

export default CategoriesCombo;
